import { DatapointsEntityType } from "api/ux/src";
import { DashboardTypes } from "components/workspaces/hooks/types";
export const dashboardTypeToEntityType = (dashboardType) => {
    if (dashboardType === DashboardTypes.Asset) {
        return DatapointsEntityType.Asset;
    }
    if (dashboardType === DashboardTypes.Fund) {
        return DatapointsEntityType.Fund;
    }
    if (dashboardType === DashboardTypes.FundSeries) {
        return DatapointsEntityType.FundSeries;
    }
    if (dashboardType === DashboardTypes.Manager) {
        return DatapointsEntityType.Manager;
    }
    if (dashboardType === DashboardTypes.Market) {
        return DatapointsEntityType.Market;
    }
    return DatapointsEntityType.Portfolio;
};
export var FundDataExportTypes;
(function (FundDataExportTypes) {
    FundDataExportTypes["AllFunds"] = "AllFunds";
    FundDataExportTypes["All"] = "All";
})(FundDataExportTypes || (FundDataExportTypes = {}));
